import React from "react";
import { Badge } from "@/components/ui/badge";

const statusConfig = {
  // Jobs
  pending: { label: "Pending", className: "bg-yellow-500/10 text-yellow-500 border-yellow-500/20" },
  assigned: { label: "Assigned", className: "bg-blue-500/10 text-blue-500 border-blue-500/20" },
  in_transit: { label: "In Transit", className: "bg-orange-500/10 text-orange-500 border-orange-500/20" },
  delivered: { label: "Delivered", className: "bg-emerald-500/10 text-emerald-500 border-emerald-500/20" },
  cancelled: { label: "Cancelled", className: "bg-red-500/10 text-red-500 border-red-500/20" },
  // Invoices
  draft: { label: "Draft", className: "bg-zinc-500/10 text-zinc-400 border-zinc-500/20" },
  sent: { label: "Sent", className: "bg-blue-500/10 text-blue-500 border-blue-500/20" },
  paid: { label: "Paid", className: "bg-emerald-500/10 text-emerald-500 border-emerald-500/20" },
  overdue: { label: "Overdue", className: "bg-red-500/10 text-red-500 border-red-500/20" },
  // Drivers
  available: { label: "Available", className: "bg-emerald-500/10 text-emerald-500 border-emerald-500/20" },
  on_trip: { label: "On Trip", className: "bg-orange-500/10 text-orange-500 border-orange-500/20" },
  off_duty: { label: "Off Duty", className: "bg-zinc-500/10 text-zinc-400 border-zinc-500/20" },
  // Vehicles
  active: { label: "Active", className: "bg-emerald-500/10 text-emerald-500 border-emerald-500/20" },
  maintenance: { label: "Maintenance", className: "bg-yellow-500/10 text-yellow-500 border-yellow-500/20" },
  inactive: { label: "Inactive", className: "bg-zinc-500/10 text-zinc-400 border-zinc-500/20" },
  // Expenses
  approved: { label: "Approved", className: "bg-emerald-500/10 text-emerald-500 border-emerald-500/20" },
  rejected: { label: "Rejected", className: "bg-red-500/10 text-red-500 border-red-500/20" },
  // Priority
  high: { label: "High", className: "bg-red-500/10 text-red-500 border-red-500/20" },
  medium: { label: "Medium", className: "bg-yellow-500/10 text-yellow-500 border-yellow-500/20" },
  low: { label: "Low", className: "bg-blue-500/10 text-blue-500 border-blue-500/20" },
};

export function StatusBadge({ status }) {
  const config = statusConfig[status] || { label: status, className: "bg-zinc-500/10 text-zinc-400 border-zinc-500/20" };
  return (
    <Badge variant="outline" className={`${config.className} text-[10px] uppercase tracking-wider font-semibold rounded-sm border px-2 py-0.5`}>
      {config.label}
    </Badge>
  );
}
